var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mds-tabs',_vm._l((_vm.parsers),function(parser){return _c('mds-tabs-item',{key:parser.id,attrs:{"active":parser.name === _vm.selectedTab},nativeOn:{"click":function($event){return _vm.setActiveNavItemOnClick(parser.name)}}},[_vm._v(" "+_vm._s(parser.name)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }